import React from "react";

const EliteJobLoginPop = ({ closePopup, closeChecked, setCloseChecked }) => {
  const handleOnChange = () => {
    setCloseChecked(!closeChecked);
  };

  return (
    <>
      <div className="container-fluid basicform">
        <form>
          <div className="form-group">
            <label htmlFor="remark" style={{ fontSize: "12px" }}>
              Elite Infotech<sup style={{ color: "red" }}>*</sup>
            </label>
            <input
              id="remark"
              style={{ fontSize: "13px" }}
              type="text"
              className="form-control form-control-sm"
              name="remark"
              //   value={absentFormValue.remark}
              //   onChange={handleChange}
            />
            <p className="errormsg " style={{ marginBottom: "0" }}>
              {/* {absentFormError.remark} */}
            </p>
          </div>
          <div className="form-group">
            <label htmlFor="remark" style={{ fontSize: "12px" }}>
              Email<sup style={{ color: "red" }}>*</sup>
            </label>
            <input
              id="remark"
              style={{ fontSize: "13px" }}
              type="text"
              className="form-control form-control-sm"
              name="remark"
              //   value={absentFormValue.remark}
              //   onChange={handleChange}
            />
            <p className="errormsg " style={{ marginBottom: "0" }}>
              {/* {absentFormError.remark} */}
            </p>
          </div>
          <div className="form-group">
            <label htmlFor="remark" style={{ fontSize: "12px" }}>
              Password<sup style={{ color: "red" }}>*</sup>
            </label>
            <input
              id="remark"
              style={{ fontSize: "13px" }}
              type="password"
              className="form-control form-control-sm"
              name="remark"
              //   value={absentFormValue.remark}
              //   onChange={handleChange}
            />
            <p className="errormsg " style={{ marginBottom: "0" }}>
              {/* {absentFormError.remark} */}
            </p>
          </div>
        </form>
      </div>
      <div className="FormFooter">
        <div className="checkedClose">
          <input
            type="checkbox"
            className="form-check-input"
            id="exampleCheck2"
            name="closeChecked"
            onChange={handleOnChange}
            checked={closeChecked}
          />
          <label class="form-check-label" for="exampleCheck2">
            Exit after submit
          </label>
        </div>
        <div>
          <button
            className="btn btn-sm btn-cmpy ml-2"
            style={{ background: "green" }}
            // onClick={formSubmit}
          >
            Submit
          </button>
          <button className="btn btn-sm btn-cmpy ml-2" onClick={closePopup}>
            Cancel
          </button>
        </div>
      </div>
    </>
  );
};

export default EliteJobLoginPop;
